import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, input } from '@angular/core';
import { TooltipDirective } from '../../directives/tooltip.directive';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-fieldset',
  template: `
    <fieldset
      [ngClass]="{
        'flex items-center justify-between gap-4': horizontal(),
      }"
      class="fieldset select-none"
    >
      @if (label() || tooltip()) {
      <div class="flex items-center gap-3">
        <div class="flex flex-col gap-1">
          @if (label(); as label) {
          <legend class="relative min-w-max flex items-center gap-1">
            <span class="text-base font-medium text-zinc-800">
              {{ label }}
            </span>
            @if (required()) {
            <span
              class="bg-primary-500 w-1.5 h-1.5 rounded-full inline-block align-middle"
            ></span>
            }
          </legend>
          } @if(hint()){
          <p class="text-zinc-400 text-sm">{{ hint() }}</p>
          }
        </div>
        @if (tooltip(); as tooltip) {
        <div class="flex w-full justify-end">
          <app-icon
            [appTooltip]="tooltip"
            name="material-symbols:info"
            class="text-gray-500 mt-1"
          />
        </div>
        }
      </div>
      }
      <div [ngClass]="contentTextSize() ? contentTextSize() : 'text-sm'">
        <ng-content></ng-content>
      </div>
    </fieldset>
  `,
  imports: [CommonModule, Icon, TooltipDirective],
})
export class Fieldset {
  required = input<boolean, string>(false, { transform: booleanAttribute });
  label = input<string>('');
  tooltip = input<string>('');
  contentTextSize = input<string>('text-sm');
  hint = input<string>('');

  horizontal = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });
}
